import React, { useState, useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "../../styles/components/content.css"
import "../../styles/general.css";
import "../../styles/components/forms.css";
import {Table} from '../shared/table.js'
import { getAllGiftForms } from "../../services/form-service";
import { CSVLink } from "react-csv";




export default function GiftFormAdmin({id, showFullVersion = true}) {
  const [gifts, SetGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAccessTokenSilently, user } = useAuth0();
  

useEffect(() => {
  const retrieveGifts = async () => {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const result = await getAllGiftForms(token);            
      SetGifts(result.data);
      setLoading(false);
  }
  retrieveGifts();
}, [])

const columns = React.useMemo(
  () => [
    {
      Header: 'Jersey Info',
      columns: [
        {
          Header: 'First Name',
          accessor: 'firstName',
        },
        {
          Header: 'Last Name',
          accessor: 'lastName',
        },
        {
          Header: 'Jacket Name',
          accessor: 'jerseyName',
        },
        {
          Header: 'Jacket Number',
          accessor: 'jerseyNumber',
          Cell: row => <div style={{ textAlign: "center" }}>{row.value}</div>
        },
        {
          Header: 'Jacket Size',
          accessor: 'jerseySize',
        }
      ],
    },
    
  ],
  []
)


  return (
    
    <>
      <div className="generic-title"> Gift Request Admin</div>
      <CSVLink data={gifts} className="btn btn1 tableCSVBtn" filename={"jersey-report.csv"}>Download CSV</CSVLink>
      <Table columns={columns} data={gifts} />
      </>
   
  )


}